import * as React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../Services/AuthContext";

const Home = () => {
    const { push } = useHistory();
    const [auth] = useAuth();

    useEffect(() => {
        if (auth.jwt) {
            push('/charterRequests/Me/Live');
        }
    }
        , [auth.jwt,push]);
    return (<React.Fragment>
        <h1>Welcome to Jetbidders!</h1>
        <p>a new single-page application, built with:</p>
        <h5>React</h5>
        </React.Fragment>);


}
export default Home; 